import { Component, EventEmitter, Input, Output } from '@angular/core'
import {
	ControlValueAccessor,
	FormGroup,
	FormsModule,
	NG_VALUE_ACCESSOR,
	ReactiveFormsModule,
} from '@angular/forms'
import {
	MatRadioButton,
	MatRadioChange,
	MatRadioGroup,
} from '@angular/material/radio'
import { NgStyle } from '@angular/common'

export type RadioOptionValue = string | number

export interface RadioOption {
	label: string
	value: RadioOptionValue
}

@Component({
	selector: 'radio-group',
	templateUrl: './RadioGroup.Component.html',
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: RadioGroupComponent,
			multi: true,
		},
	],
	imports: [
		FormsModule,
		ReactiveFormsModule,
		MatRadioButton,
		MatRadioGroup,
		NgStyle,
	],
})
export class RadioGroupComponent implements ControlValueAccessor {
	@Input() public value: RadioOptionValue

	@Input() public readonly form: FormGroup

	@Input() public readonly id: string

	@Input() public readonly error: string

	@Input() public readonly formControlName: string

	@Input() public readonly options: RadioOption[]

	@Output() public readonly valueChange = new EventEmitter<RadioOptionValue>()

	private onTouched: () => void

	private onChange: (value: string) => void

	public handleChange = (event: MatRadioChange): void => {
		this.value = event.value
		this.valueChange.emit(this.value)
	}

	public registerOnChange(fn: (value: string) => void): void {
		this.onChange = fn
	}

	public registerOnTouched(fn: () => void): void {
		this.onTouched = fn
	}

	public writeValue(value: string): void {
		this.value = value
		this.valueChange.emit(this.value)
	}

	public optionTracker = (index: number) => index
}
